import actionTypes from './action-types';
import cookieUtil from 'tradera-utils/cookie';
import Analytics from 'packages/analytics';
import logger from 'packages/logger';
import locationUtils from 'tradera-utils/location';
import api from './api';

import { LANGUAGE_TOOLTIP_DISMISSED_COOKIE } from 'tradera-constants/cookies';

const yearInMilliseconds = 1000 * 60 * 60 * 24 * 365;

/**
 * Sets new preferred language
 * @param {string} code - example: 'sv' or 'en'
 */
export const setPreferredLanguage = (
    code,
    toLocalizedUrl
) => async dispatch => {
    Analytics.trackEvent({
        category: 'Settings',
        action: 'Language',
        label: code
    });

    try {
        await api.saveLanguageSetting(code, toLocalizedUrl);

        dispatch({
            type: actionTypes.SET_PREFERRED,
            payload: code
        });
        locationUtils.reload();
    } catch (error) {
        logger(error);
    }
};

export const dismissLanguageTooltip = () => {
    Analytics.trackEvent({
        category: 'Top navigation',
        action: 'Localization menu tooltip',
        label: 'Dismiss'
    });

    const expireDate = new Date(new Date().getTime() + yearInMilliseconds);
    cookieUtil.createCookie(
        LANGUAGE_TOOLTIP_DISMISSED_COOKIE,
        true,
        expireDate
    );

    return {
        type: actionTypes.DISMISS_TOOLTIP
    };
};

export const dismissLanguageOptoutTooltip = () => {
    Analytics.trackEvent({
        category: 'Top navigation',
        action: 'Localization menu opt-out tooltip',
        label: 'Dismiss'
    });

    const expireDate = new Date(new Date().getTime() + yearInMilliseconds);
    cookieUtil.createCookie(
        LANGUAGE_TOOLTIP_DISMISSED_COOKIE,
        true,
        expireDate
    );

    return {
        type: actionTypes.DISMISS_OPTOUT_TOOLTIP
    };
};
